<template>
	<ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
		<li @click="refreshSelectedTag" v-if="isRefresh">
			<el-icon><Refresh style="width: 1em; height: 1em" /></el-icon>
			刷新页面
		</li>
		<li @click="closeSelectedTag" v-if="isCloseSelected">
			<el-icon><CloseBold style="width: 1em; height: 1em" /></el-icon>
			关闭当前
		</li>
		<li @click="closeOthersTags" v-if="isCloseOthers">
			<el-icon><CircleCloseFilled style="width: 1em; height: 1em" /></el-icon>
			关闭其他
		</li>
		<li @click="closeLeftTags" v-if="isCloseLeft">
			<el-icon><Back style="width: 1em; height: 1em" /></el-icon>
			关闭左侧
		</li>
		<li @click="closeRightTags" v-if="isCloseRight">
			<el-icon><Right style="width: 1em; height: 1em" /></el-icon>
			关闭右侧
		</li>
	</ul>
</template>

<script setup>
import { Refresh, CloseBold, CircleCloseFilled, Back, Right } from '@element-plus/icons-vue'

// Props
const props = defineProps({
	visible: {
		type: Boolean,
		default: false
	},
	left: {
		type: Number,
		default: 0
	},
	top: {
		type: Number,
		default: 0
	},
	isRefresh: {
		type: Boolean,
		default: true
	},
	isCloseSelected: {
		type: Boolean,
		default: true
	},
	isCloseOthers: {
		type: Boolean,
		default: true
	},
	isCloseLeft: {
		type: Boolean,
		default: true
	},
	isCloseRight: {
		type: Boolean,
		default: true
	}
})

// Emits
const emit = defineEmits([
	'refresh-selected-tag',
	'close-selected-tag',
	'close-others-tags',
	'close-left-tags',
	'close-right-tags'
])

// Methods
const refreshSelectedTag = () => {
	emit('refresh-selected-tag')
}

const closeSelectedTag = () => {
	emit('close-selected-tag')
}

const closeOthersTags = () => {
	emit('close-others-tags')
}

const closeLeftTags = () => {
	emit('close-left-tags')
}

const closeRightTags = () => {
	emit('close-right-tags')
}
</script>

<style scoped lang="scss">
.contextmenu {
	margin: 0;
	background: #fff;
	z-index: 3000;
	position: absolute;
	list-style-type: none;
	padding: 5px 0;
	border-radius: 4px;
	font-size: 12px;
	font-weight: 400;
	color: #333;
	box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
	border: 1px solid #e4e7ed;

	li {
		margin: 0;
		padding: 7px 16px;
		cursor: pointer;
		height: 30px;
		display: flex;
		align-items: center;
		gap: 8px;

		&:hover {
			background: #eee;
		}
	}
}
</style>
